"use client";

import { legacyIconCls } from "@faire/web/slate/utils/tracking";
import React from "react";

import { createSVGIcon } from "./util";

/**
 * @trackcomponent
 * @optimized using svgo:^3.0.2
 */
export const FastTime = createSVGIcon(
  <>
    <circle cx="20" cy="8" r="7.5" stroke="currentColor" />
    <path
      d="M20 4.5v3.875l3 2.125M5 4h5M5 12h5M1 8h8"
      stroke="currentColor"
      strokeLinecap="round"
    />
  </>,
  "FastTime",
  {
    viewBox: "0 0 28 16",
    titleAccess: "FastTime",
    fill: "none",
    className: legacyIconCls(),
  }
);
